import { useState } from "react";
import { SubmitButton } from "../main/form";

export default function Randomize() {
  const items: any[] = JSON.parse(localStorage.getItem("current") ?? "[]").map(
    (i: any) => i.value
  );

  const randomize = (arr: string[]) =>
    arr[Math.floor(Math.random() * arr.length)];

  const [result, setResult] = useState(randomize(items));

  const handleClick = () => setResult(randomize(items));

  return (
    <>
      <div className="mx-6">
        <h1 className="text-center font-bold text-2xl my-20">{result}</h1>
        <SubmitButton onClick={handleClick}>Randomize again</SubmitButton>
      </div>
    </>
  );
}
